import * as React from "react";
import {TableCell,TableHead,TableRow,TableSortLabel,Box} from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import { headCells } from "./Utils/TableHeadList";

// export interface Data {
//     id: number;
//     sno?:number;
//     procedureTitle: string;
//     price: number;
//     gst: number;
//     activeStatus: any;
//     createdAt: string; 
//     updatedAt: string;
//   }
  

interface EnhancedTableProps {
  onRequestSort: (
    event: React.MouseEvent<unknown>,
    property: keyof any
  ) => void;
  order: any;
  orderBy: any;
}

function EnhancedTableHead(props: EnhancedTableProps) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler :any =
    (property: keyof any) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
          className="table-head text-nowrap"
            key={headCell.id}
            align="left"
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
export default React.memo(EnhancedTableHead);
